function threeDigits(money) {
  if (Number.isNaN(Number(money))) {
    return '';
  }
  return ((money || money === 0) && money.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')) || money;
}

export default threeDigits;
